
import { Component, ElementRef, OnInit } from "@angular/core";

import { ActivatedRoute, Router } from "@angular/router";

import { NotificationService } from "src/app/Service/notification.service";

import { OtherService } from "src/app/Service/other.service";

import Chart from 'chart.js/auto';

import axios from "src/app/Service/axios";

import { Location } from '@angular/common';

import Map from 'ol/Map';

import View from 'ol/View';

import * as olProj from 'ol/proj';

import {

  DragRotateAndZoom,

  defaults as defaultInteractions,

} from 'ol/interaction';


import Feature from 'ol/Feature';

import { Tile as TileLayer } from 'ol/layer';

import OSM from 'ol/source/OSM';

import { Point } from "ol/geom";

import { BingMaps, Cluster, Vector, XYZ } from "ol/source";

import AnimatedCluster from "ol-ext/layer/AnimatedCluster";

import SelectCluster from "ol-ext/interaction/SelectCluster";

import { Tile } from "ol/layer";

import { MapService } from "src/app/Service/map.service";

import { DeviceDetectorService } from "ngx-device-detector";

import { Circle, Fill, Icon, Stroke, Style, Text } from "ol/style";

import "ol/ol.css";

import * as XLSX from 'xlsx';

import zoomPlugin from 'chartjs-plugin-zoom';

import { getRelativePosition } from 'chart.js/helpers';

import { FormBuilder, FormControl, FormGroup, NgForm } from "@angular/forms";

import { DataService } from "src/app/Service/data.service";

import { Observable, map, startWith } from "rxjs";

import VectorSource from "ol/source/Vector";

import VectorLayer from "ol/layer/Vector";

import { animate, state, style, transition, trigger } from '@angular/animations';

import { GurdServiceService } from "src/app/Service/gurd-service.service";


declare let $: any;
@Component({

  selector: 'app-search-drivers',

  templateUrl: './search-drivers.component.html',

  styleUrls: ['./search-drivers.component.css'],

  animations: [

    trigger('fadeAnimation', [

      state('void', style({ opacity: 0 })),

      transition(':enter', [

        animate('300ms ease-in', style({ opacity: 1 }))

      ]),

      transition(':leave', [

        animate('100ms ease-out', style({ opacity: 0 }))

      ])

    ])

  ]

})

export class SearchDriversComponent implements OnInit {

  list_Schools = [];

  list_Drivers = [];

  list_search = [];

  filteredSchools = [];

  lstDrivers_Student = [];

  searchT_School = '';

  iMobileDomain: string = '-1';

  detail: any = [];

  isLoading: boolean = false;

  map: any;

  source: any;

  source2: any;

  vector: any;

  vector2: any;

  layers: any = [];

  layers2: any = [];


  private bOfflineMap: boolean = (<any>window).bOfflineMap;

  private strMapUrl: string = (<any>window).strMapUrl;


  constructor(

    private router: Router,

    private Notification: NotificationService,

    private gurdService: GurdServiceService

  ) { }

  ngOnInit(): void {

    this.getSchools();


  }

  filterSchool() {

    if (this.searchT_School == '') {

      this.filteredSchools = [];

      this.iMobileDomain = '-1';

    }

    else this.filteredSchools = this.list_Schools.filter((item: any) => item.strComment.includes(this.searchT_School));
  }

  searchBy(search: any) {

    if (search.length > 2) {

      this.list_Drivers = this.list_search.filter((el: any) => {

        return el.strFullName.includes(search) || el.strMobile.includes(search) || el.strMobileDomain_strComment.includes(search)

      })
    }

    else if (search == '') this.list_Drivers = this.list_search

  }

  goBack() {

    this.router.navigate(['/'])
  }

  async getSchools() {

    var model = {

      iSystemUser: this.gurdService.decrypt(localStorage.getItem('ID')!),

      strSession: this.gurdService.decrypt(localStorage.getItem('Session')!),

    }

    let res = JSON.parse((await axios.post(`School_User_List`, model)).data.toString())

    this.list_Schools = res;

  }

  async searchDrivers(form: NgForm) {

    this.isLoading = true;

    form.value['iSystemUser'] = this.gurdService.decrypt(localStorage.getItem('ID')!);

    form.value['strSession'] = this.gurdService.decrypt(localStorage.getItem('Session')!);

    form.value['iMobileDomain'] = this.iMobileDomain;

    let res = JSON.parse((await axios.post(`School_Mobile_Search`, form.value)).data.toString());

    this.list_Drivers = res.dtMobile;

    this.list_search = res.dtMobile;

    this.isLoading = false;

  }

  formatted_pelak(strVehicle: any) {

    return `ایران ${strVehicle.split(' ')[4]} | ${strVehicle.split(' ')[2]} ${strVehicle.split(' ')[1]} ${strVehicle.split(' ')[0]}`;

  }

  async showDetail(item: any) {

    var model = {

      iSystemUser: this.gurdService.decrypt(localStorage.getItem('ID')!),

      strSession: this.gurdService.decrypt(localStorage.getItem('Session')!),

      strUnitID: item.strUnitID

    }

    let res = JSON.parse((await axios.post(`School_Mobile_Passengers`, model)).data.toString());

    this.lstDrivers_Student = res;

    this.detail = item;

    $('#driver_detail').modal('show')

  }

  async calculateKm() {

    var model = {

      iSystemUser: this.gurdService.decrypt(localStorage.getItem('ID')!),

      strSession: this.gurdService.decrypt(localStorage.getItem('Session')!),

      strUnitID: this.detail.strUnitID

    }

    let distance: number = 0;

    let duration: number = 0

    let res = (await axios.post(`School_CallTripDirection`, model)).data.toString();

    if (res == '') return this.Notification.showError('اطلاعاتی یافت نشد');

    else res = JSON.parse(res)

    res.routes[0].legs.forEach((a: any) => {

      distance += a.distance.value;

      duration += a.duration.value;

    })

    $.confirm({

      title: `طول مسیر و زمان مسیر به شرح زیر است : `,

      content: ` طول مسیر : <strong>${(distance / 1000).toFixed(1)}</strong> کیلومتر  <br> زمان مسیر : <strong>${Math.round(duration / 60)}</strong> دقیقه`,

      type: 'blue',

      buttons: {

        cancel: {

          text: "تایید",

        }

      }

    });

  }

  sortBy(input: any) {

    this.list_Drivers.sort((a: any, b: any) => {

      switch (input) {

        case 0:
          var textA = a.strFullName.toUpperCase();
          var textB = b.strFullName.toUpperCase();
          break;

        case 1:
          var textA = a.strMobile.toUpperCase();
          var textB = b.strMobile.toUpperCase();
          break;

        default:
          break;
      }

      if (textA > textB) return (textA < textB) ? 1 : (textA > textB) ? -1 : 0;

      if (textA < textB) return (textA < textB) ? -1 : (textA > textB) ? 1 : 0;

      return 0;
    })

  }

  exportExcel() {

    setTimeout(() => {

      let element = document.getElementById('Export_Excel');

      const ws: XLSX.WorkSheet = XLSX.utils.table_to_sheet(element);

      const wb: XLSX.WorkBook = XLSX.utils.book_new();

      XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');

      XLSX.writeFile(wb, 'جستجو و مرور راننده.xlsx');

    }, 200);

  }

  showOnMap(item: any) {

    $('#stdLocation').modal('show');

    setTimeout(() => {

      if (this.map) this.map.setTarget(null);

      this.source = new VectorSource({ wrapX: false });

      this.vector = new VectorLayer({

        source: this.source,

      });

      var iconStyle = new Style({

        image: new Icon(({

          anchor: [0, 46],

          anchorXUnits: 'fraction',

          anchorYUnits: 'pixels',

          size: [48, 48],

          opacity: 1,

          src: '../../assets/Img/marker4.png'

        }))

      });


      if (this.bOfflineMap) {

        this.layers.push(

          new TileLayer({

            source: new XYZ({

              // url: 'http://your-local-server/tiles/{z}/{x}/{y}.png',

              url: this.strMapUrl,

              attributions: 'Map data © RayanAndishehNasr' // 

            }),

          })

        );

      }

      else {

        const styles = [

          'AerialWithLabelsOnDemand',

        ];

        let i, ii;

        for (i = 0, ii = styles.length; i < ii; ++i) {

          this.layers.push(

            new TileLayer({

              visible: false,

              preload: Infinity,

              source: new BingMaps({

                // key: 'AkUPx3euT5YcJeljnCtLb7aEpgoCLc9hMqiQj291YVL_4pSJJtVSjHFnDlDdJELM',
                key: 'Ap0AObt84NcDaUThCeWOj52ZqUHv6k4TJhjLibR-DghC-semgoj-0uPbIi8r0E4j',

                imagerySet: styles[i],

              }),

            }),

          );
        }

        this.layers.push(new TileLayer({ source: new OSM({}), }), this.vector)


      }



      this.map = new Map({

        layers: this.layers,

        target: 'map',

        view: new View({

          center: olProj.fromLonLat([item.fOriginLon, item.fOrigiLat]),

          zoom: 13,

        }),

      });

    }, 500);

  }

}
